<template>
    <span class="ui-inline-jetton">
        <!-- Split amount on simple table, so we can style int and fractional parts separately -->
        <span v-if="!isMobile && $store.state.transactionViewData === 'simple'" class="ui-inline-jetton__value">
            <tx-amount v-bind:amount="meta.amount_in" v-bind:decimals="meta.decimals_in" />
        </span>
        <span v-else class="ui-inline-jetton__value">
            {{$ton(meta.amount_in, meta.decimals_in, isMobile || round)}}
        </span>
        <!-- Ticker -->
        <ui-link
            v-if="meta.jetton_in_address !== null && meta.jetton_in_address !== 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez'"
            class="ui-inline-jetton__link tx-table-jetton-link-standart"
            v-bind:to="{ name: 'jetton', params: { address: meta.jetton_in_address }}"
        >
            {{ truncateTicker(meta.symbol_in) || shortenAddress(meta.jetton_in_address) }}
        </ui-link>
        <span v-else>
            TON
        </span>
        <IconArrowRight class="swap-icon-arrow" />
        <!-- Right side -->
        <!-- Split amount on simple table, so we can style int and fractional parts separately -->
        <span v-if="!isMobile && $store.state.transactionViewData === 'simple'" class="ui-inline-jetton__value" v-bind:class="{'ui-inline-jetton--green': !isFailed}">
            <tx-amount v-bind:amount="meta.amount_out" v-bind:decimals="meta.decimals_out" />
        </span>
        <span v-else class="ui-inline-jetton__value" v-bind:class="{'ui-inline-jetton--green': !isFailed}">
            {{$ton(meta.amount_out, meta.decimals_out, isMobile || round)}}
        </span>
        <!-- Ticker -->
        <ui-link
            v-if="meta.jetton_out_address !== null && meta.jetton_out_address !== 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez'"
            class="ui-inline-jetton__link" v-bind:class="{'ui-inline-jetton--green': !isFailed, 'tx-table-jetton-link-standart': isFailed}"
            v-bind:to="{ name: 'jetton', params: { address: meta.jetton_out_address }}"
        >
            {{ truncateTicker(meta.symbol_out) || shortenAddress(meta.jetton_out_address) }}
        </ui-link>
        <span v-bind:style="isFailed ? '' : 'color: var(--green-bright)'" v-else>
            TON
        </span>
    </span>
</template>

<script>
import IconArrowRight from '@img/icons/tonscan/arrow-small-right.svg?inline';
import TxAmount from '~/components/address/TxSimpleInlineAmount.vue';
import { truncateTicker } from '../../helpers';

export default {
    props: {
        meta: {
            type: Object,
        },
        round: {
            type: Boolean,
            default: true,
            required: false,
        },
        isFailed: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        truncateTicker,
        shortenAddress(address) {
            return address.slice(0, 3) + '...' + address.slice(-3);
        },
    },
    components: {
        TxAmount,
        IconArrowRight,
    },
};
</script>

<style lang="scss">
.swap-icon-arrow {
    opacity: .7;
    width: 10px;
    height: 12px;
    margin: 0 6px;
}
</style>
